import { Box, Chip, Paper, Typography, useTheme } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import type ResearchFindingStore from "./ResearchFindingStore";
import {
    formatRunDate,
    formatRunTime,
    runStatusColor,
} from "./researchFindingsUtils";

type Props = {
    store: ResearchFindingStore;
};

/** Summary banner for the selected run. */
const RunDetailHeader: React.FC<Props> = observer(({ store }) => {
    const theme = useTheme();
    const detail = store.detail;
    if (!detail) return null;

    const questionCount = store.questions.length;
    const answerCount = store.answerCount;

    const parts: string[] = [
        `${questionCount} question${questionCount === 1 ? "" : "s"}`,
        `${answerCount} answer${answerCount === 1 ? "" : "s"}`,
    ];

    return (
        <Paper
            elevation={0}
            sx={{
                padding: theme.spacing(2.5),
                borderRadius: "8px",
                border: `1px solid ${theme.palette.gray[200]}`,
                backgroundColor: theme.palette.gray[100],
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                }}
            >
                <Box>
                    <Typography
                        sx={{
                            fontSize: "18px",
                            fontWeight: 600,
                            color: theme.palette.gray[700],
                        }}
                    >
                        {formatRunDate(detail.startedAtUtc)} ·{" "}
                        {formatRunTime(detail.startedAtUtc)}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: "13px",
                            color: theme.palette.gray[500],
                            mt: 0.5,
                        }}
                    >
                        {parts.join(" · ")}
                        {detail.subjectUserName
                            ? ` · Subject: ${detail.subjectUserName}`
                            : ""}
                    </Typography>
                </Box>
                {detail.status && (
                    <Chip
                        label={detail.status}
                        color={runStatusColor(detail.status)}
                        variant="outlined"
                    />
                )}
            </Box>
        </Paper>
    );
});

export default RunDetailHeader;
